// Angular DOM
import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
// Third Party Services
import {
  ActivatedRoute,
  ActivatedRouteSnapshot, NavigationEnd,
  NavigationExtras,
  NavigationStart,
  Router,
  RouterStateSnapshot,
  RoutesRecognized
} from "@angular/router";
import {
  NgbModal,
  NgbModalOptions,
  NgbDatepickerConfig
} from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
// Redux Store
import {Store} from "@ngrx/store";
import {SetPatientAction, SetPatientSearchCriteria} from "../../actions";
// Models
import {Patient, RegexPattern} from "../../models";
// Services
import {
  AuthService,
  PatientService,
  UtilService,
  DuplicateFinderService
} from "../../services";
import {Subscription} from "rxjs/Subscription";
import {Ethnicity} from "../../models/ethnicity";
import {EthnicityService} from "../../services/ethnicity/ethnicity.service";
import {Location} from "@angular/common";

@Component({
  selector: "app-patient-details-modal",
  templateUrl: "./patient-details-modal.component.html",
  styleUrls: ["./patient-details-modal.component.scss"]
})
export class PatientDetailsNewModalComponent
  implements OnInit, AfterViewInit, OnDestroy, AfterContentChecked {
  @ViewChild("content") template: TemplateRef<any>;

  public redirect: string;
  public modalRef: any;
  public patient: any;
  public confirm: boolean = false;
  public editMode: boolean = false;
  public modalTitle = "Create a New Patient";
  public showPatientExistsError = false;
  public isOfficeStaff: any;
  public dateOfBirth: { year: number; month: number; day: number };
  public currentDate = moment().format("YYYY-MM-DD");
  public dobYear: any;
  public dobMonth: any;
  public dobDay: any;
  public futureDate: any;
  public minYear: boolean;
  public ethnicities: Array<Ethnicity> = [];

  public subscriptions: { [name: string]: Subscription } = {};
  public regexModel: RegexPattern;
  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-details",
    keyboard: false
  };
  public searchCriteria: SearchCriteria;
  public duplicatePatients: any[];
  private mode: string;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private store: Store<any>,
    private authService: AuthService,
    private config: NgbDatepickerConfig,
    private duplicateFinderService: DuplicateFinderService,
    private ethnicityService: EthnicityService,
    private location: Location
  ) {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    // customize default values of datepickers used by this component tree
    this.config.minDate = {year: 1900, month: 1, day: 1};
    this.config.maxDate = {year, month, day};
    // days that don't belong to current month are not visible
    this.config.outsideDays = "hidden";
    this.regexModel = new RegexPattern();
  }

  ngOnInit() {
    this.ethnicityService.getEthnicity().subscribe(values => {
      this.ethnicities = values;
    });

    this.mode = "new-mode";
    this.subscriptions["redirect"] = this.route.queryParams.subscribe(
      params => {
        this.redirect = params["redirect"] || "";
      }
    );

    this.subscriptions["patient"] = this.store
      .select("patient")
      .subscribe(patient => {
        this.patient = Object.assign({}, new Patient(), patient);
        const dob = this.patient.Dob ? this.patient.Dob.split("-") : null;
        dob !== null
          ? (this.dateOfBirth = {
            year: Number(dob[0]),
            month: Number(dob[1]),
            day: Number(dob[2])
          })
          : (this.dateOfBirth = null);
      });

    this.searchCriteria = {
      PageNumber: 1,
      Sort: "LastName",
      Order: "ASC",
      SearchTerm: this.patient
    };
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  ngAfterContentChecked() {
    let currentDateObject = this.currentDate.split("-");
    this.dobYear = Number(currentDateObject[0]);
    this.dobMonth = Number(currentDateObject[1]);
    this.dobDay = Number(currentDateObject[2]);
    if (this.dateOfBirth) {
      this.minYear = this.dateOfBirth.year < this.config.minDate.year;
      this.futureDate = this.dateOfBirth.year > this.dobYear || (this.dateOfBirth.year == this.dobYear && this.dateOfBirth.month > this.dobMonth)
        || (this.dateOfBirth.year == this.dobYear && this.dateOfBirth.month == this.dobMonth && this.dateOfBirth.day > this.dobDay);
    }
  }

  cancel() {
    this.store.dispatch({type: "CLEAR_PATIENT"});
    this.store.dispatch({type: "CLEAR_TEST_ORDER"});

    this.location.back();
  }

  createUpdatePatient() {
    this.duplicateFinderService.confirmDuplicatePatient(
      this.dateOfBirth,
      this.patient,
      this.mode
    );
    let navigationExtras: NavigationExtras = {
      queryParams: {redirect: this.redirect}
    };
    this.router.navigate(
      ["/patients/create/additional-details"],
      navigationExtras
    );
  }

  isString(val) {
    return typeof val === "string";
  }

  checkFormValidity(form) {
    let detectNonAlphaRegex = /[^a-zA-Z]/g;
    return form.invalid || detectNonAlphaRegex.test(this.patient.MiddleName) || this.futureDate || this.minYear;
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });

    for (let el in this.subscriptions) {
      if (el) {
        this.subscriptions[el].unsubscribe();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/patient-details-modal/patient-details-new-modal.component.ts